import styled from "styled-components";

export const Wrapper = styled.div`
  max-width: 100%;
`;

export const TableWrapper = styled.div`
  margin-bottom: 10px;
`;

export const Table = styled.table`
  width: 100%;

  ${(p) =>
    p.isSummary &&
    `
    th, td {
      padding-left: 10px;
      padding-right: 10px;
    }

    td {
      max-width: 300px;
      word-break: break-word;
    }
  `}
`;

export const THead = styled.thead`
  background-color: rgb(0, 102, 153);
  color: #f5f5f5;
  border-left: 1px solid rgb(0, 102, 153);
  border-right: 1px solid rgb(0, 102, 153);
`;

export const TBody = styled.tbody`
  background-color: #f5f5f5;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;

  & tr {
    border-bottom: 1px solid #ccc;

    &:nth-child(even) {
      background-color: #ececec;
    }
  }
`;

export const TFoot = styled.tfoot`
  & td {
    text-align: right;
  }
`;

export const TR = styled.tr``;

export const TRVertical = styled.tr`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  padding: 12px;
  border: 1px solid #ccc;
  background-color: #f8f8f8;
`;

export const TH = styled.th`
  padding: 6px 3px;
  min-width: ${(p) =>
    p.minWidth === "auto" ? "fit-content" : `${p.minWidth}px`};
  text-align: ${(p) =>
    p.checkbox ? "center" : p.alignRight ? "right" : "left"};

  &:first-child {
    padding-left: 6px;
  }

  &:last-child {
    padding-right: 6px;
  }
`;

export const TD = styled.td`
  padding: 6px 3px;
  position: relative;
  text-align: ${(p) => (p.alignRight ? "right" : "left")};

  display: ${(p) => (p.sum ? "flex" : "")};

  &:first-child {
    padding-left: 6px;
  }

  &:last-child {
    padding-right: 6px;
  }

  ${(p) =>
    p.checkbox &&
    `
    text-align: center;
  `}

  ${(p) =>
    p.error &&
    `
    & > * {
      background-color: ${p.theme.backgrounds.danger} !important;
      border-color: ${p.theme.borders.danger} !important;
      position: relative;
    }
  `}
`;

export const Input = styled.input`
  padding: 0 8px;
  width: 100%;
  height: 32px;
  border: none;
  border: 1px solid #888;
  border-radius: 4px;

  &[type="number"] {
    -moz-appearance: textfield;
    text-align: right;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  }
`;

export const Select = styled.select`
  padding: 0 4px;
  width: 100%;
  height: 32px;
  border: none;
  border: 1px solid #888;
  border-radius: 4px;
`;

export const Checkbox = styled.div`
  margin: ${(p) => (p.vertical ? "0 6px" : "0 auto")};
  padding-left: 1px;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: ${(p) =>
    p.disabled ? "#ddd" : p.checked ? "#0375fe" : "#fff"};
  border-radius: 2px;
  border: ${(p) => (p.checked ? "1px solid #0375fe" : "1px solid #888")};

  ${(p) =>
    p.checked &&
    `
    &:before {
      content: '\f00c';
      font-family: 'Font Awesome 5 Pro';
      color: #fff;
      font-weight: bold;
      font-size: 10px;
    }
  `}

  & > input {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
`;

export const EditButton = styled.button`
  padding: 0;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  float: right;
  margin-right: 12px;
  border: 1px solid #888;
  border-radius: 2px;
  background-color: #ddd;
  color: #444;
  opacity: ${(p) => (p.disabled ? 0.5 : 1)};
`;

export const EditButtonCell = styled.button`
  padding: 0;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  float: left;
  margin-left: 4px;
  margin-top: 4px;
  border: 1px solid #888;
  border-radius: 2px;
  background-color: #ddd;
  color: #444;
  opacity: ${(p) => (p.disabled ? 0.5 : 1)};
`;

export const EditIcon = styled.em``;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const AddButton = styled.button`
  padding: 5px 10px;
  border: 1px solid rgb(0, 102, 153);
  border-radius: 4px;
  background-color: rgb(0, 102, 153);
  color: #f5f5f5;

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;

export const CheckIcon = styled.em``;

export const Tooltip = styled.div`
  padding: 5px 10px;
  position: absolute;
  top: calc(100% - 3px);
  left: 3px;
  background-color: rgba(0, 0, 0, 0.8) !important;
  color: #f5f5f5;
  border-radius: 4px;
  font-size: 0.8rem;
  display: none;
  white-space: nowrap;
  z-index: 1;

  &:before {
    content: "";
    display: block;
    position: absolute;
    bottom: 100%;
    left: 10px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid rgba(0, 0, 0, 0.8);
  }

  ${TD}:hover & {
    display: block;
  }
`;

export const TDInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RowLabel = styled.label`
  color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  text-align: left;
  letter-spacing: 0.1em;
  font-weight: 700;
  background-color: #f5f5f5 !important;
  margin: 0;
  margin-bottom: 6px;
`;

export const Label = styled.label`
  margin: 0px 0px 5px 5px;
`;
